import styled from '@emotion/styled'
import { tokens } from '../../theme.js'
import { IconOnlyButton } from '../../components/styles/Buttons.js'

const colors = tokens.colors
const fontFamily = tokens.fonts.body

export const ProjectsBody = styled.div`
  padding: 40px;
  width: 100%;
  box-sizing: border-box;
`
export const ProjectGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));
  gap: 20px;
  margin-top: 24px;
`
export const ProjectCard = styled.div`
  position: relative;
  background: ${colors.white};
  border: 1px solid ${p => (p.$active ? colors.primary : colors.sectionDivider)};
  border-radius: ${tokens.borderRadius.div};
  padding: 24px;
  min-height: 120px;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    border-color: ${colors.primary};
  }
`
export const NewProjectCard = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 120px;
  height: 100%;
  box-sizing: border-box;
  border: 1px solid ${colors.text.muted};
  border-radius: ${tokens.borderRadius.div};
  background: transparent;
  cursor: pointer;
  align-self: stretch;
  font: 500 14px/1.3 ${fontFamily};
  color: ${colors.primary};
  &:hover {
    border-color: ${colors.primary};
  }
`
export const ProjectName = styled.div`
  font: 600 16px/1.35 ${fontFamily};
  color: ${colors.text.heading};
  padding-right: 36px;
`
export const ProjectMenuButton = styled(IconOnlyButton)`
  position: absolute;
  top: 18px;
  right: 18px;
`
